import { get } from '../../../container';

export const AUTHENTICATION_LOADING = 'AUTHENTICATION_LOADING';
export const AUTHENTICATION_SUCCESS = 'AUTHENTICATION_SUCCESS';
export const AUTHENTICATION_FAILURE = 'AUTHENTICATION_FAILURE';
export const LOGOUT = 'LOGOUT';

export function isAuthenticated() {
  return (dispatch) => {
    const type = get('authenticator').isAuthenticated() ? AUTHENTICATION_SUCCESS : AUTHENTICATION_FAILURE;

    dispatch({ type });
  };
}

/**
 * @param {Boolean} isUnauthorized
 */
export function logout(isUnauthorized) {
  return (dispatch) => {
    get('authenticator').removeToken();

    dispatch({ type: LOGOUT, payload: { isUnauthorized } });
  };
}

/**
 * @param {String} username
 * @param {String} password
 */
export function login(username, password) {
  return (dispatch) => {
    dispatch({ type: AUTHENTICATION_LOADING });

    get('api').login(username, password, ({ token }) => {
      get('authenticator').createToken(token);

      dispatch({ type: AUTHENTICATION_SUCCESS });
    }, (status) => dispatch({ type: AUTHENTICATION_FAILURE, payload: { status } }));
  };
}



// WEBPACK FOOTER //
// ./src/modules/auth/actions/auth.js